import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers';
// import dayjs from 'dayjs';
// import utc from "dayjs/plugin/utc";
// dayjs.extend(utc);

const DatePickerAccessCodeComponent = ({maxDate,label,isFilterDisabled,handleChange,minDate,value}) => {
  return (
    <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker 
            label={label}  
            //maxDate={dayjs(maxDate)}
            //minDate={dayjs(minDate)} 
            maxDate={maxDate}
            minDate={minDate}
            disabled={isFilterDisabled} 
            format="YYYY-MM-DD"
            value={value}
            onChange={(date) => {
              // const localDate = new Date(date);
              handleChange(date);
            }}
            slotProps={{
              textField: {
                readOnly: true,
                fullWidth: true,
                error: false, 
              },
          }}
          />
        </LocalizationProvider>
    </>
  )
}

export default DatePickerAccessCodeComponent